import { connect } from 'react-redux';
import { compose } from 'redux';
import moment from 'moment';
import withContent from '../../../containers/withContent';
import paymentContent from './payment.content';
import Payment from '../../../../src/fasterPayments/components/Payments/Payment';
import {
	updateToAccount,
	updateFromAccount,
	updateAmount,
	updateDate,
	updateType,
	updateAllDates,
	updateReference,
	updateAllFromAccounts,
	removePayment,
	resetPaymentAuthorisation,
} from '../../../../src/states/payments/actions';
import { initValidation, updateValidation, hideErrorMsg } from '../../../../src/states/validation/actions';
import { getValidationRowState } from '../../../../src/states/validation/selectors';
import {
	getAccountIsBillerOrCreditCard,
	isFutureDatedPaymentUnsupported,
} from '../../../../src/states/accounts/selectors';
import { isPayee, isSingleUsePayee, getToPayeeCopCheckRequired } from '../../../../src/states/payees/selectors';
import { calcMaxAmountForPaymentType } from '../../../../src/states/modes/selectors';

export const isSavingsAccount = (accounts, id) => {
	const account = accounts.find((account) => account.id === id);
	return !!account && account.type === 'savings';
};

export const isCreditCard = (accounts, id) => {
	const account = accounts.find((account) => account.id === id);
	return !!account && account.type === 'credit_card';
};

const mapState = (state, props) => ({
	validations: getValidationRowState(state, props.id),
	isRefDisabled: getAccountIsBillerOrCreditCard(state, props.toAccount),
	isToPayee: isPayee(state, props.toAccount),
	isToSingleUsePayee: isSingleUsePayee(state, props.toAccount),
	isFutureDatedPaymentUnsupported: isFutureDatedPaymentUnsupported(state, props.fromAccount, props.toAccount),
	maxAmountForPaymentType: calcMaxAmountForPaymentType(state, isPayee(state, props.toAccount)),
	isToPayeeCopCheckRequired: getToPayeeCopCheckRequired(state, props.toAccount),
});

const mapDispatch = (dispatch, props) => ({
	handleSelectFromAccount: (fromAccountId, accounts) => {
		if (props.updateAllOnChange) {
			dispatch(updateAllFromAccounts(fromAccountId));
			return;
		}
		dispatch(updateFromAccount({ id: props.id, accountId: fromAccountId }));
		dispatch(
			updateAmount({
				id: props.id,
				amount: '',
			})
		);
		dispatch(
			updateReference({
				id: props.id,
				reference: '',
			})
		);
		const offset = props.type === 'repeating' ? 1 : 0;
		dispatch(updateDate({ id: props.id, date: moment().add(offset, 'day') }));
		if (isSavingsAccount(accounts, fromAccountId) || isCreditCard(accounts, fromAccountId)) {
			if (props.type === 'repeating') {
				dispatch(updateType({ id: props.id, paymentType: 'single' }));
			}
		}
	},
	handleSelectType: (typeId) =>
		dispatch(
			updateType({
				id: props.id,
				paymentType: typeId,
			})
		),
	handleRemovePayment: () =>
		dispatch(
			removePayment({
				id: props.id,
			})
		),
	handleAmountBlur: (value = '') => {
		if (props.amount !== value) {
			dispatch(
				updateAmount({
					id: props.id,
					amount: value,
				})
			);
		}
	},
	handleDateChange: (date) => {
		if (props.updateAllOnChange) dispatch(updateAllDates({ date: date || moment() }));
		const offset = props.type === 'repeating' ? 1 : 0;
		dispatch(updateDate({ id: props.id, date: date || moment().add(offset, 'day') }));
	},
	handleRefChange: (ref) => dispatch(updateReference({ id: props.id, reference: ref })),
	initValidation: () =>
		dispatch(
			initValidation({
				id: props.id,
				templateMode: props.templateMode,
			})
		),
	updateValidation: (key, isValid) =>
		dispatch(
			updateValidation({
				id: props.id,
				key,
				isValid,
			})
		),
	hideErrorMsg: (key) =>
		dispatch(
			hideErrorMsg({
				id: props.id,
				key,
			})
		),
	resetPaymentAuthorisation: () =>
		dispatch(
			resetPaymentAuthorisation({
				id: props.id,
			})
		),
});

export default compose(connect(mapState, mapDispatch), withContent({ content: paymentContent }))(Payment);
